export default __webpack_public_path__ + "static/media/consignment.c7cf218d.svg";